@if ((configuration$ | async)?.formats?.length > 0) {
  <button class="btn btn-primary"
    [innerHTML]="'context-menu.actions.export-item.btn' | translate"
    (click)="$event.preventDefault();openExportModal();">
  </button>
}
